import * as Yup from "yup";

export const UpdatesValidationSchema = Yup.object().shape({
  formType: Yup.string().required(),
  displayTitle: Yup.string().required(),
  updateType: Yup.string().required(),
});
